<template>
  <svg
    width="9"
    height="6"
    viewBox="0 0 9 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1L4.5 4.5L8 1"
      stroke="#417CE9"
      stroke-width="2"
      stroke-linecap="round"
      class="stroke"
    />
  </svg>
</template>

<style lang="scss" scoped>
@use "@/assets/scss/variables" as *;

.arrow-btn svg {
  width: 8px;
  height: 14px;
}
.arrow-btn svg .stroke {
  stroke: $white;
}
.disable svg .stroke {
  stroke: #545454;
}
.arrow-left svg {
  transform: rotate(90deg);
  margin-right: 2px;
}
.arrow-right svg {
  transform: rotate(-90deg);
  margin-left: 2px;
}
</style>
